import React from 'react';
import UFOSegment from '@atlaskit/react-ufo/segment';
import { JSErrorBoundary } from '@atlassian/jira-error-boundaries/src/ui/js-error-boundary/JSErrorBoundary.tsx';
import type { RecommendationsList$key } from '@atlassian/jira-relay/src/__generated__/RecommendationsList.graphql';
import { RecommendationsList } from './recommendations-list/RecommendationsList.tsx';

type Props = {
	recommendationsRef: RecommendationsList$key;
};

export const RecommendedProjects: React.FC<Props> = ({ recommendationsRef }) => {
	return (
		<UFOSegment name="recommended-projects">
			<JSErrorBoundary
				id="recommended-projects"
				packageName="jiraProjectsDirectoryRecommendations"
				teamName="helios-headcoach"
				fallback="flag"
			>
				<RecommendationsList recommendationsRef={recommendationsRef} />
			</JSErrorBoundary>
		</UFOSegment>
	);
};
